<template>
    <div class="text-xs-center py-5" style="height: 300px">
        <v-progress-circular
        :size="50"
        :width="3"
        color="primary"
        indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
export default {
    
}
</script>
